module.exports = __webpack_public_path__ + "img/1505809533.ee82a38f.jpg";